import classNames from "classnames";
import React from "react";
import imgBreadCrum from "../../assets/img/mex/accidentesPersonales/imgbreadcrumAP.png";

const BreadCrumbSegukids = ({
  title,
  subtitle,
  img = imgBreadCrum,
  pasos,
  subtitleStyles = {},
  subtitleClassnames = "",
  styleimg = "",
  pasosActivos,
  showImg = true,
  showImgTitle = false,
  styleWidthImg,
  classNameContent,
}) => {
  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className={`col-md-12 col-lg-12 ${classNameContent}`}>
          <div className="w-100 d-flex flex-row">
            <div
              className={`d-none d-sm-block align-self-center ${styleWidthImg}`}
            >
              {styleimg !== "" && showImg && (
                <img src={img} className={styleimg} alt="" />
              )}
              {styleimg === "" && showImg && (
                <img
                  src={img}
                  className="img-fluid mr-2"
                  alt=""
                  style={{ height: "200px" }}
                  loading="lazy"
                />
              )}
            </div>
            <div className="d-flex flex-column w-100 align-self-center">
              <h1 className="font-mex text-mex" style={{ fontSize: "50px" }}>
                {showImgTitle ? (
                  <img
                    src={title}
                    className="img-fluid mr-2"
                    alt=""
                    style={{ height: "80px" }}
                    loading="lazy"
                  />
                ) : (
                  <span>{title}</span>
                )}
              </h1>
              <div className="border-step">
                <div className="step-segukids d-flex flex-wrap justify-content-between ">
                  {pasos.map((paso, index) => {
                    return (
                      <div
                        className={classNames("flex-fill", {
                          active: pasosActivos?.includes?.(index + 1),
                        })}
                        key={index}
                        style={{
                          fontSize: "20px",
                          borderLeft: "#001871 1px solid",
                        }}
                      >
                        {paso.title}
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className={subtitleClassnames} style={subtitleStyles}>
                <h5
                  className="subtitle-breadcum-cot-tipo2"
                  style={{ fontSize: "19px" }}
                >
                  {subtitle}
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BreadCrumbSegukids;
